// defines the individual toast product/tier that a guest could be using to place their order
enum ToastProduct {
  OOPro = 'OOPro',
  OOBasic = 'OOBasic',
  OOEcommerce = 'OOEcommerce',
  ToastLocal = 'ToastLocal',
  Sites = 'Sites',
  FreeOOToastLocal = 'FreeOOToastLocal',
  ToastApp = 'ToastApp'
}

/**
 * Narrower than "Toast Local" — excludes www.toasttab.com/local (ToastLocal,
 * FreeOOToastLocal) and merchant-branded online ordering.
 */
export const isToastAppProduct = (toastProduct?: ToastProduct) =>
  toastProduct === ToastProduct.ToastApp

export default ToastProduct
